import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';

import { SN_DRAWER_DATA } from '@lib/ui/drawer';

export interface ISnChannelMembersDrawerData {
  sid: string;
}

@Component({
  templateUrl: './channel-members-drawer.container.html',
  styleUrls: ['./channel-members-drawer.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnChannelMembersDrawerContainer {
  public sid: string;
  public isExternal: boolean;

  constructor(@Inject(SN_DRAWER_DATA) data: ISnChannelMembersDrawerData) {
    this.sid = data.sid;
  }
}
